// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalParent_modal__3mR9y","header":"ModalParent_header__4vINx","yes":"ModalParent_yes__39wKn"};